require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
module.exports = require('../../modules/$.core').Symbol;


//////////////////
// WEBPACK FOOTER
// ../~/vue2-google-maps/~/core-js/library/fn/symbol/index.js
// module id = 1108
// module chunks = 0